const getConstraintProperty = (constraints = [], property) =>
  constraints.find(constraint => property in constraint.property)?.property[property]

export const isFieldValueEmpty = value => (typeof value === 'string' ? !value.trim() : !value)

// `pattern`/`notnull` are HTML constraint-validation attributes, but the form sets `noValidate`
// (custom error UI), so the browser never enforces them — we replicate the checks here instead.
export const getFieldConstraintError = (field, value) => {
  const {constraints, required} = field

  if (required && isFieldValueEmpty(value)) return 'notnull'

  const pattern = getConstraintProperty(constraints, 'pattern')
  if (!isFieldValueEmpty(value) && pattern && typeof value === 'string' && !new RegExp(pattern).test(value)) {
    return 'pattern'
  }

  return null
}

export const isFieldValueValid = (field, value) => getFieldConstraintError(field, value) === null
